import React, { Component } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

class Box extends Component {
  render () {
    let boxInnerClassname = 'box-inner'
    if (this.props.innerCentered) {
      boxInnerClassname += ' box-inner-centered'
    }
    if (!this.props.hasInnerBackground) {
      boxInnerClassname += ' box-inner-no-bg'
    }
    return (
      <div className="box" style={this.props.style}>
        <div className={boxInnerClassname}>{this.props.children}</div>
      </div>
    )
  }
}

Box.defaultProps = {
  style: {},
  innerCentered: true,
  innerHasBackground: true
}
Box.propTypes = {
  style: PropTypes.object,
  innerCentered: PropTypes.bool,
  hasInnerBackground: PropTypes.bool
}
export default Box
